import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalInvesting: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={3} {...props}>
            <IconPath
                stroke="currentColor"
                d="m17 6-3.919 4.183c-.148.158-.223.237-.312.278a.5.5 0 0 1-.253.044c-.098-.01-.194-.06-.387-.16L8.87 8.656c-.192-.1-.289-.15-.387-.16a.5.5 0 0 0-.253.044c-.09.04-.164.12-.312.278L4 13"
                strokeLinecap="round"
                strokeLinejoin="round"
                {...pathProps}
            />
        </IconSVG>
    );
};
